export enum ComponentType {
    DIGITAL_NAMEPLATE = "digital-nameplate",
    BATTERY_PASS = "battery-pass",
    GEMUE_INTERNAL = "gemue-internal",
    GEMUE_EXTERNAL = "gemue-external"
}